import { Modal, Button, Input } from "antd";
import { resetAccountPasswordApi } from "api/account";
import { useNotificationContext } from "contexts/NotificationContext";
import { IAccount } from "models/account";
import { useState } from "react";
import KeyIcon from "components/Icons/KeyIcon";

interface IProp {
  open: boolean;
  account: IAccount;
  handleClose: () => void;
}

export default function ResetPasswordModal({ open, account, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");
  const { showError, showSuccess } = useNotificationContext();

  const handleReset = async () => {
    if (!password || password.length < 6) {
      showError("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);
    const { data, error } = await resetAccountPasswordApi(account.id, password);
    if (data) {
      showSuccess("Password reset successfully");
      setPassword("");
      handleClose();
    } else {
      showError(error?.message || "Failed to reset password");
    }
    setLoading(false);
  };

  return (
    <Modal open={open} title="Force Reset Password" onCancel={handleClose} footer={null} centered>
      <div className="w-full pt-4">
        <div className="w-full text-blue-500 text-6xl flex justify-center mb-6">
          <KeyIcon />
        </div>
        <p className="text-center mb-6 text-gray-600">
          Set a new temporary password for <strong>{account.first_name} {account.last_name}</strong>.
        </p>
        <div className="mb-6">
          <Input.Password
            placeholder="New temporary password"
            size="large"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="w-full flex items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleReset}
            loading={loading}
            type="primary"
            className="bg-blue-600"
          >
            Reset Password
          </Button>
        </div>
      </div>
    </Modal>
  );
}
